import { useEffect, useState } from "react";
import { adminApi } from "@/admin/api";
import { toast } from "sonner";
import { Mail, MailOpen, CheckCheck, Trash2, X } from "lucide-react";

export default function Messages() {
  const [rows, setRows] = useState([]);
  const [active, setActive] = useState(null);

  const load = () => adminApi.get("/admin/messages").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const open = async (m) => {
    setActive(m);
    if (!m.read) { await adminApi.patch(`/admin/messages/${m.id}`, { read: true }); load(); }
  };
  const toggleReplied = async (m) => { await adminApi.patch(`/admin/messages/${m.id}`, { replied: !m.replied }); toast.success(m.replied ? "Marked unreplied" : "Marked replied"); load(); if (active?.id === m.id) setActive({ ...m, replied: !m.replied }); };
  const del = async (id) => { if (!window.confirm("Delete this message?")) return; await adminApi.delete(`/admin/messages/${id}`); toast.success("Deleted"); setActive(null); load(); };

  const unread = rows.filter((r) => !r.read).length;

  return (
    <div className="space-y-5">
      <h1 className="text-xl font-bold text-gray-900" data-testid="messages-heading">Messages <span className="text-sm font-normal text-gray-400" data-testid="unread-count">({rows.length}{unread ? `, ${unread} unread` : ""})</span></h1>
      <div className="bg-white rounded-xl border border-gray-200 overflow-x-auto">
        <table className="w-full text-sm" data-testid="messages-table">
          <thead className="bg-gray-50 text-left text-xs uppercase tracking-wider text-gray-500">
            <tr><th className="p-3 w-8"></th><th className="p-3">From</th><th className="p-3">Subject</th><th className="p-3">Date</th><th className="p-3">Status</th></tr>
          </thead>
          <tbody>
            {rows.map((m) => (
              <tr key={m.id} onClick={() => open(m)} data-testid={`message-row-${m.id}`} className={`border-t border-gray-100 hover:bg-gray-50 cursor-pointer ${!m.read ? "font-semibold" : ""}`}>
                <td className="p-3 text-gray-400">{m.read ? <MailOpen size={15} /> : <Mail size={15} className="text-[hsl(13_65%_54%)]" />}</td>
                <td className="p-3"><div className="text-gray-800">{m.name}</div><div className="text-xs text-gray-400 font-normal">{m.email}</div></td>
                <td className="p-3 text-gray-700 font-normal">{m.subject || "(no subject)"}</td>
                <td className="p-3 text-xs text-gray-500 font-normal">{new Date(m.created_at).toLocaleString("en-IN")}</td>
                <td className="p-3 font-normal">{m.replied ? <span className="text-emerald-600 text-xs inline-flex items-center gap-1"><CheckCheck size={13} /> Replied</span> : <span className="text-amber-600 text-xs">Pending</span>}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan="5" className="p-8 text-center text-gray-400 font-normal">No messages yet.</td></tr>}
          </tbody>
        </table>
      </div>

      {active && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={() => setActive(null)}>
          <div className="bg-white rounded-2xl p-6 w-full max-w-lg" onClick={(e) => e.stopPropagation()} data-testid="message-detail">
            <div className="flex items-start justify-between mb-4">
              <div>
                <h2 className="font-semibold text-gray-900">{active.subject || "(no subject)"}</h2>
                <p className="text-sm text-gray-500">{active.name} · {active.email}{active.phone ? ` · ${active.phone}` : ""}</p>
                <p className="text-xs text-gray-400">{new Date(active.created_at).toLocaleString("en-IN")}</p>
              </div>
              <button data-testid="message-close" onClick={() => setActive(null)}><X size={18} /></button>
            </div>
            <p className="text-sm text-gray-700 whitespace-pre-wrap leading-relaxed">{active.message}</p>
            <div className="flex flex-wrap gap-2 mt-6">
              <a href={`mailto:${active.email}?subject=${encodeURIComponent("Re: " + (active.subject || "Your enquiry to Findivine"))}`} className="rounded-lg bg-[hsl(13_65%_54%)] text-white px-4 py-2 text-sm font-medium">Reply by Email</a>
              <button data-testid="toggle-replied" onClick={() => toggleReplied(active)} className="rounded-lg border border-gray-300 px-4 py-2 text-sm">{active.replied ? "Mark Unreplied" : "Mark Replied"}</button>
              <button data-testid="delete-message" onClick={() => del(active.id)} className="rounded-lg border border-gray-300 px-3 py-2 text-sm text-red-600"><Trash2 size={15} /></button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
